import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe used for sorting an array of objects by a property value within that array.
 */
@Pipe({
  name: 'sort',
  standalone: true
})
export class ArraySortPipe implements PipeTransform {
  /**
   * Transforms the original data source and outputs a sorted version of the array.
   */
  public transform<T>(array: Array<T>, sortField?: string, sortOrder: 'asc' | 'desc' = 'asc'): Array<T> {
    if (array) {
      const result: Array<T> = array.sort((a: T, b: T): number => {
        const firstValue: unknown =
          sortField && typeof a === 'object' && a !== null ? (a as Record<string, unknown>)[sortField] : a;
        const secondValue: unknown =
          sortField && typeof b === 'object' && b !== null ? (b as Record<string, unknown>)[sortField] : b;

        if (firstValue < secondValue) {
          return sortOrder === 'desc' ? 1 : -1;
        } else if (firstValue > secondValue) {
          return sortOrder === 'desc' ? -1 : 1;
        } else {
          return 0;
        }
      });

      return result;
    } else {
      return undefined;
    }
  }
}
